export const environment = {
    production: false,
    apiUrl: 'https://signcorc-tst-api.azurewebsites.net',
    msalConfig: {
        clientId: '9fc57342-c80b-4060-9ddf-fc85324b4324',
        authority:
            'https://signcoauth.b2clogin.com/signcoauth.onmicrosoft.com/B2C_1A_CUSTOM_SIGNIN',
        knownAuthority: 'signcoauth.b2clogin.com',
        scopes: ['https://signcoauth.onmicrosoft.com/signcoserv/user.access'],
    },
    signalR: {
        hubUrl: 'https://signcorc-tst-api.azurewebsites.net/hubs/device',
    },
    session: {
        timeoutWarningSeconds: 60,
    },
    features: {
        activityLog: true,
    },
    webgl: {
        // Load the obfuscated WebGL build when a version has one. Must match the 'ignore' glob
        // for 'assets/webgl/*/normal/**' in angular.json: a build that leaves out the readable
        // copy needs this to be true.
        useObfuscatedBundle: true,
    },
};
